import { ofType } from "redux-observable";
import { of } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { utilBalancing } from "../../utils/utilBalancing";
import { utilMap } from "../../utils/utilMap";
import { TypeActionLoading } from "../loading/actionLoading";
import { actionBalancingRegistered } from "./actionBalancing";
export var createEpicBalancing = function (bundleId, configs) { return function (action$) {
    return action$.pipe(ofType(TypeActionLoading.Complete), filter(function (action) { return action.bundleId === bundleId; }), switchMap(function (action) {
        configs.map(function (config) {
            var data = config.dataExtractor(action.loader.resources[config.id]);
            var result = config.convertToMap ? utilMap.toMap(data, config.mapKeyProp) : data;
            utilBalancing.setKey(config.id, result);
        });
        // TODO: we need to read balancing version so we can reset only when we update balancing.
        utilBalancing.resetCache();
        return of(actionBalancingRegistered());
    }));
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/balancing/createEpicBalancing.ts
// module id = 1784
// module chunks = 3